/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Confirmed_Installment_CountInputs */

const en_case_payment_validation_confirmed_installment_count = /** @type {(inputs: Case_Payment_Validation_Confirmed_Installment_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The installment count cannot exclude a confirmed installment.`)
};

const pt_br2_case_payment_validation_confirmed_installment_count = /** @type {(inputs: Case_Payment_Validation_Confirmed_Installment_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A quantidade de parcelas não pode excluir uma parcela confirmada.`)
};

/**
* | output |
* | --- |
* | "The installment count cannot exclude a confirmed installment." |
*
* @param {Case_Payment_Validation_Confirmed_Installment_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_confirmed_installment_count = /** @type {((inputs?: Case_Payment_Validation_Confirmed_Installment_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Confirmed_Installment_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_confirmed_installment_count(inputs)
	return pt_br2_case_payment_validation_confirmed_installment_count(inputs)
});